import DOMPurify from "dompurify";

export interface UnsanitizedHtml {
  potentiallyDangerousHtml: string;
}

export interface SanitizedHtml {
  __html: string;
}

export interface SanitizeHtmlParams extends UnsanitizedHtml {
  config?: Parameters<typeof DOMPurify.sanitize>[1];
}

/**
 * Sanitizes HTML content using DOMPurify to prevent XSS attacks.
 * Returns an object that can be passed to React's dangerouslySetInnerHTML.
 *
 * @param params - The sanitization parameters
 * @param params.potentiallyDangerousHtml - The HTML string to sanitize
 * @param params.config - Optional DOMPurify configuration
 * @returns Object with sanitized HTML suitable for dangerouslySetInnerHTML
 *
 * @example
 * ```tsx
 * <div dangerouslySetInnerHTML={sanitizeHtml({ potentiallyDangerousHtml: userInput })} />
 * ```
 */
export function sanitizeHtml(params: SanitizeHtmlParams): SanitizedHtml {
  const { potentiallyDangerousHtml, config } = params;

  return {
    __html: String(DOMPurify.sanitize(potentiallyDangerousHtml, config)),
  };
}
